import * as React from "react";
function SvgIcTableColumnCategorical(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.046 19.817a.6.6 0 01-.066-.003l-.213-.067-.107-.08-5.738-4.842-.404-3.724a.628.628 0 01.106-.451.654.654 0 01.449-.238L15.852 10l.192.015.21.13 5.675 4.562.071.287a.62.62 0 01-.138.449l-3.486 4.302-.254.067a.536.536 0 01-.076.005zM12.9 14.56l5.102 4.098 2.84-3.543-5.097-4.097-3.193.346.348 3.196zm.613-1.56a1 1 0 102 0 1 1 0 00-2 0zM2 3h20v4H2V3zm1 1v2h18V4H3zM2 8h7v4H2V8zm1 1v2h5V9H3zm-1 4h7v4H2v-4zm1 1v2h5v-2H3zm-1 4h7v4H2v-4zm1 1v2h5v-2H3z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcTableColumnCategorical;
